import { defineSetting } from '../settingsRegistry';

declare module '../settingsRegistry' {
  interface Settings {
    /** J10: after 60 s without input in a safe zone, out of combat, the character sits and meditates. */
    idleSit: boolean;
  }
}

defineSetting({
  key: 'idleSit',
  default: true,
  order: 140,
  menu: { group: 'data', label: 'นั่งสมาธิเองเมื่อว่างนาน 60 วินาทีในเขตปลอดภัย' },
});
